import { Controller } from "@hotwired/stimulus"
import {
  addItemToRecentSearches,
  hide,
  show,
  openRecentSearch,
  fillRecentSearches,
} from "@/frontend/utils/searchHelpers"

const FORM_ID = "search_by_text_form_desktop"

export default class extends Controller {
  static targets = [
    "textSearchEl",
    "quidedSearchEl",
    "recentSearchEl",
    "input",
    "recentTiles",
    "styleFilter",
    "sizeFilter",
    "priceFilter",
  ]

  connect() {
    this.clickOutside = this.clickOutside.bind(this)
    this.openRecentSearch = openRecentSearch.bind(this, FORM_ID)
    this.fillRecentSearches = fillRecentSearches.bind(this)
  }

  clickOutside(e) {
    if (this.element.contains(e.target)) return

    hide([this.recentSearchElTarget])

    document.removeEventListener("click", this.clickOutside)
  }

  openTextSearch(event) {
    const filterName = event?.target?.dataset?.filter || "style"
    this.parentFilter = filterName
    this.currentParentFilter(filterName).open = false
    this.currentParentFilterController().removeListener()
    show([...this.textSearchElTargets, this.recentSearchElTarget])
    hide(this.quidedSearchElTargets)
    this.inputTarget.focus()
    this.fillRecentSearches()
    document.addEventListener("click", this.clickOutside)
  }

  backToGuidedSearch() {
    this.currentParentFilter().open = true
    setTimeout(() => this.currentParentFilterController().addListener(), 0)
    hide(this.textSearchElTargets)
    show(this.quidedSearchElTargets)
    hide([this.recentSearchElTarget])

    document.removeEventListener("click", this.clickOutside)
  }

  onFormSubmit() {
    addItemToRecentSearches(this.inputTarget.value)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside)
  }

  currentParentFilter(filter = null) {
    // Sometimes the this.parentFilter is empty right after setting up.
    return this[`${filter || this.parentFilter}FilterTarget`]
  }

  currentParentFilterController() {
    return this.application.getControllerForElementAndIdentifier(this.currentParentFilter(), "details-click-outside")
  }
}
